﻿'use strict';

angular.module('ntmApp')
  .directive('iconDisplay', function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/directives/templates/iconDisplay.html',
          scope: {
              icon: '=',
              width: '=',
              height: '=',
              forceConvertToAwesomeIcon: '=',
          },
          link: function (scope) {
              if (scope.forceConvertToAwesomeIcon) {
                  var icon = null;

                  if (scope.icon && scope.icon.length > 0) {
                      icon = '{"type": "awesome", "image": "' + scope.icon + '"}';
                  } else {
                      icon = '{"type": "awesome", "image": ""}';
                  }

                  scope.model = icon ? JSON.parse(icon) : {};
              } else {
                  scope.model = scope.icon ? JSON.parse(scope.icon) : {};
              }
          }
      };
  });